<template>
  <div>
    <v-row>
      <v-col cols="12" sm="3">
        <v-select
          v-model="filter.filial"
          :items="$store.getters['admin/filials']"
          :label="$t('fields.filial')"
          item-value="idx"
          item-text="name"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" sm="3">
        <v-select
          v-model="filter.tag"
          :items="$store.getters['admin/postags']"
          :label="$t('fields.tags')"
          clearable
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="posusers"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      show-expand
      class="transparent"
      item-key="idx"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit({ status: 1, rules: {} })" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{item, headers}">
        <td :colspan="headers.length">
          <v-row>
            <v-col v-for="k in details" :key="k.value">
              <div class="subtitle-2">{{k.text}}</div>
              <div>{{format(item, k.value)}}</div>
            </v-col>
          </v-row>
        </td>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
        <v-btn icon @click="showBinTable(item)">
          <v-icon color="grey">mdi-information</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.status="{ item }">{{$t("status.rec_" + item.status)}}</template>
      <template
        v-slot:item.terminal="{ item }"
      >{{$store.getters["admin/terminal"](item.terminal).description}}</template>
      <template
        v-slot:item.server="{ item }"
      >{{$store.getters["admin/lss"]($store.getters["admin/terminal"](item.terminal).lss).name}}</template>
      <template v-slot:item.filial="{ item }">{{ $store.getters["admin/filial"](item.filial).name }}</template>
      <template v-slot:item.deviceid="{ item }">
        <v-icon>{{item.deviceid?"mdi-check":"mdi-cancel" }}</v-icon>
      </template>
      <template v-slot:item.status="{ item }">
        <v-icon
          :color="item.status==1?'success':'error'"
        >{{item.status==1?"mdi-check":"mdi-cancel" }}</v-icon>
      </template>
      <template v-slot:item.created="{ item }">{{ item.created | dt-time }}</template>
      <template v-slot:item.updated="{ item }">{{ item.updated | dt-time }}</template>
    </v-data-table>
    <v-dialog v-model="d_bintable" persistent width="500">
      <v-card color="teal lighten-4">
        <v-card-title>
          <i18n path="dialog.ttl.binTable" />
          <v-spacer></v-spacer>
          <v-btn @click="d_bintable = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <template v-for="(o,k) in bintable">
            <div :key="k" class="mb-4">
              <v-img :src="$api.resources+k+'/system.svg?t='+new Date().getTime()" height="150">
                <span class="text-h5 white--text ma-4">{{k}}</span>
                <span class="text-h5 white--text">{{o.name}}</span>
              </v-img>
            </div>
            <div v-for="op in o.opers" :key="op.name" class="ml-8 mb-2">
              <v-img
                :src="$api.resources+k+'/operations/'+op.oper+'.svg?t='+new Date().getTime()"
                height="100"
              >
                <span class="text-h5 white--text ma-4">{{op.oper}}</span>
                <span class="text-h5 white--text">{{op.name}}</span>
              </v-img>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <i18n path="admin.posuser">
            <template #idx>
              <span>{{ item.idx }}</span>
            </template>
          </i18n>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" :href="$api.resources+'/posuser.html'" link target="blank_">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn @click="d_edit = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.name"
              :error-messages="user_errors"
              :label="$t('fields.login')"
              :rules="[(v) => !!v || $t('error.required')]"
            ></v-text-field>
            <v-text-field v-model="item.description" :label="$t('fields.description')"></v-text-field>
            <v-select
              v-model="item.terminal"
              :items="$store.getters['admin/terminals']"
              item-text="description"
              item-value="idx"
              :label="$t('fields.terminal')"
            ></v-select>
            <v-select
              v-model="item.filial"
              :items="$store.getters['admin/filials']"
              item-text="name"
              item-value="idx"
              :label="$t('fields.filial')"
            ></v-select>
            <v-select v-model="item.status" :items="$t('statuses')" :label="$t('fields.status')"></v-select>
            <v-text-field
              v-model="newpass"
              :label="$t('fields.newpass')"
              append-icon="mdi-dice-multiple-outline"
              @click:append="generatePass"
            ></v-text-field>
            <v-text-field v-model="item.tags" :label="$t('fields.tags')"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn icon @click="(dmode = 'delete'), (d_confirm = true)" color="error">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="d_delDevId = true" color="warning">{{ $t("button.delDevId") }}</v-btn>
          <v-btn text @click="checkSett" color="orange">{{ $t("button.checkSett") }}</v-btn>
          <v-btn icon @click="update" color="primary">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="d_delDevId" persistent width="300">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <i18n path="dialog.ttl.delDevId" />
          <v-spacer></v-spacer>
          <v-btn @click="d_delDevId = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <!-- <v-card-text>
          <i18n path="dialog.txt.delDevId" />
          <v-checkbox v-model="delToken" :label="$t('dialog.txt.delDevToken')"></v-checkbox>
        </v-card-text> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDeviceId" color="error">
            <i18n path="dialog.btn.delDevId" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog v-model="d_confirm" :mode="dmode" @click:ok="confirmedActions" />
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import passUtils from "@/password.js";

export default {
  name: "PosUsers",
  mixins: [commonmixin],
  data() {
    return {
      user_errors: "",
      newpass: "",
      d_edit: false,
      d_bintable: false,
      //delToken: false,
      d_delDevId: false,
      filter: { filial: null, tag: null },
      item: {
        rules: {},
      },
      bintable: {},
      details: [
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.updated"), value: "updated", align: "center" },
        { text: this.$t("fields.rules"), value: "rules", align: "center" },
        { text: this.$t("fields.deviceid"), value: "deviceid" },
      ],
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          width: 130,
          divider: true,
        },
        { text: this.$t("fields.login"), value: "name" },
        {
          text: this.$t("fields.description"),
          value: "description",
          divider: true,
        },
        {
          text: this.$t("fields.filial"),
          value: "filial",
          filter: (value) => {
            return !this.filter.filial || value == this.filter.filial;
          },
        },
        { text: this.$t("fields.lss"), value: "server", sortable: false },
        { text: this.$t("fields.terminal"), value: "terminal", divider: true },
        { text: this.$t("fields.hash"), value: "deviceid" },
        { text: this.$t("fields.status"), value: "status", divider: true },
        {
          text: this.$t("fields.tags"),
          value: "tags",
          filter: (value) => {
            //if (!this.filter.bin) return true;
            return (
              !this.filter.tag ||
              (value && value.indexOf(this.filter.tag) != -1)
            );
          },
        },
      ],
    };
  },
  methods: {
    generatePass() {
      this.newpass = passUtils.generate(10);
    },
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      this.currentIdx = this.posusers.indexOf(i);
      this.newpass = "";
      this.item.pass = "";
    },
    checkSett() {
      this.$api.checkMobilePosSettings(this.item.idx).then((r) => {
        alert(JSON.stringify(r));
      });
    },
    deleteDeviceId() {
      this.$store.dispatch("admin/CLEAR_DEVICE", {
        item: this.item,
        token: true,
        index: this.currentIdx,
      });
      this.d_delDevId = false;
    },
    confirmedActions(a) {
      if (a == "delete") {
        this.$store.dispatch("admin/DELETE_POSUSER", this.item);
      }
      this.d_edit = false;
    },
    update() {
      if (this.newpass) {
        this.item.pass = this.$CryptoJS.enc.Base64.stringify(
          this.$CryptoJS.SHA256(this.newpass)
        );
      }

      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_POSUSER", {
            item: this.item,
            index: this.currentIdx,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        const prev = this.posusers.find((e) => {
          return e.name == this.item.name;
        });
        if (prev) {
          this.user_errors = this.$t("error.dublicate");
        } else {
          this.$store
            .dispatch("admin/INSERT_POSUSER", this.item)
            .then((response) => {
              if (response == 0) {
                this.user_errors = this.$t("error.api");
              } else {
                this.d_edit = false;
              }
            });
        }
      }
    },
    showBinTable(item) {
      try {
        this.bintable = {};
        this.d_bintable = true;
        const term = this.$store.getters["admin/terminal"](item.terminal);
        const lss = this.$store.getters["admin/lss"](term.lss);
        this.$api
          .loadTerminalBinTable(term.terminal, lss.domen)
          .then((response) => {
            response.forEach((e) => {
              if (!this.bintable[e.bin]) {
                this.$set(this.bintable, e.bin, { name: e.sysName, opers: [] });
              }
              this.bintable[e.bin].opers.push({
                name: e.operName,
                oper: e.oper_nr,
              });
            });
          });
      } catch (error) {
        console.log(error);
      }
    },
    format(i, k) {
      try {
        if (k == "created" || k == "updated" || k == "lastUsed")
          return this.$options.filters["dt-time"](i[k]);
        return i[k];
      } catch (error) {
        return error;
      }
    },
  },
  computed: {
    posusers() {
      return this.$store.getters["admin/posusers"];
    },
  },
  mounted() {
    if (!this.$store.getters["admin/isPosUsers"]) {
      this.$store.dispatch("admin/LOAD_POSUSERS");
    }
    if (!this.$store.getters["admin/isTerminals"]) {
      this.$store.dispatch("admin/LOAD_TERMINALS");
    }
    if (!this.$store.getters["admin/isLss"]) {
      this.$store.dispatch("admin/LOAD_LSS");
    }
    if (!this.$store.getters["admin/isFilials"]) {
      this.$store.dispatch("admin/LOAD_FILIALS");
    }
  },
};
</script>

<style>
</style>